import { c as _c } from "react/compiler-runtime";
// Ручные статусы «Доставки продавцом» у покупателя: та же лесенка, что
// продавец двигает в кабинете (Ожидает → Принят → Передан курьеру → Доставлен).
import { Check } from "lucide-react";
import { SELF_DELIVERY_STEPS, selfStepIndex } from "@/lib/delivery-labels";
import { cn } from "@/lib/utils";
export function SelfDeliverySteps(t0) {
  const $ = _c(9);
  const {
    statusCode,
    comment
  } = t0;
  const current = selfStepIndex(statusCode);
  let t1;
  if ($[0] !== current) {
    t1 = SELF_DELIVERY_STEPS.map((step, i) => <li key={step.code} className="flex items-center gap-1.5">{i > 0 && <span aria-hidden="true" className="w-3 border-t border-dashed border-[#1F1F1F]/40" />}<span aria-current={i === current ? "step" : undefined} className={cn("inline-flex items-center gap-1", i <= current ? "text-[#32D47D]" : "text-[#1F1F1F]/48", i === current && "font-medium")}>{i <= current && <Check className="size-3" strokeWidth={2} />}{step.label}</span></li>);
    $[0] = current;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <ol className="flex flex-wrap items-center gap-x-2 gap-y-1 text-[12px] leading-4">{t1}</ol>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== comment) {
    t3 = comment ? <p className="mt-1 text-[12px] leading-4 text-[#1F1F1F]/64">Комментарий продавца: {comment}</p> : null;
    $[4] = comment;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div data-testid="self-delivery-steps">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}